import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=a89311a4&scoped=true&"
import script from "./SearchView.vue?vue&type=script&lang=js&"
export * from "./SearchView.vue?vue&type=script&lang=js&"
import style0 from "./SearchView.vue?vue&type=style&index=0&id=a89311a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89311a4",
  null
  
)

export default component.exports